module.exports = __webpack_public_path__ + "img/690e1618a44007e88a6b83379c2e3a2a.png";